import { css } from '@emotion/core'
import type { Gender } from '@fs/zion-tree-types'
import React from 'react'
import { stripeColorMap } from '../../../colors'

const colorStripeCss = css`
  height: 8px;
`
export default function ColorStripe({ gender }: { gender: Gender | undefined }): JSX.Element {
  return <div css={colorStripeCss} style={{ background: stripeColorMap[gender ?? 'UNKNOWN'] }} />
}
